<template>
  <div class="sky-line-text">
    <div class="sky-line">
      <div class="line-title">
        {{data}}
      </div>
      <div
        class="line-icon"
        :style="{
          display: hideIcon
        }"
        @click="compile"
      >
        <ig-icon name="bianji1"></ig-icon>
      </div>
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  name: 'sky-line',
  props: {
    data: {
      required: true,
    },
    hideIcon: {
      type: String,
      default: 'block',
    },
  },
  methods: {
    compile() {
      this.$emit('compile')
    },
  },
}
</script>

<style lang="scss" scoped>
.sky-line-text {
  // margin-bottom: 15px;
  .sky-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .line-title {
      color: #333;
      font-size: 18px;
      line-height: 1.5em;
      user-select: none;
    }
    .line-icon {
      // display: none;
      .iconfont {
        color: #999;
        font-size: 18px;
        line-height: 1.5em;
        margin-left: 10px;
        cursor: pointer;
        user-select: none;
        &:hover {
          color: #409eff;
        }
      }
    }
    &:hover .line-icon {
      display: block;
    }
  }
  .line {
    width: 100%;
    height: 2px;
    background-color: #e8e8e8;

    margin-top: 20px;
  }
}
.sky-span {
  color: #000;
  line-height: 1.7em;
  border-bottom: 4px solid #3da1ff;
}
</style>
